import { Route, Routes } from "react-router-dom";
import IndexCaseStatus from "./status/IndexCaseStatus";

/**
 * Case Types and the admin Cases list both moved out: Case Types is
 * gone (CaseJobForm gets its options from getCaseDependenciesReq, not
 * this page), and the Cases list's create/delete actions live on
 * userCase's Total Cases page now instead.
 */
const CaseManagementRoutes = () => {
  return (
    <Routes>
      <Route path="/statuses" element={ <IndexCaseStatus /> } />
    </Routes>
  )

}

export default CaseManagementRoutes;
